import { Box, Button } from '@mui/material';
import { ArrowBackRounded } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { doc, getDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../../lib/firebase';
import { useTenantStore } from '../../stores/tenant.store';
import { GradesPage } from './grades.page';

// ─── El ACTA de una sección ─────────────────────────────────────────────────
// El registro OFICIAL de las notas finales, con o sin aula virtual (H1). Vive
// en Secciones y matrícula —que no pertenece a ningún módulo, así que se ve
// aunque el aula esté apagada— y es el MISMO libro de notas que la pestaña
// Notas de /curso: con aula, el libro propone la nota; sin aula, se escribe
// aquí. Se cierra, se reabre y llega al expediente igual en los dos casos.
//
// Quién: el profesor de la sección y Registro escriben y cierran; solo
// Registro y administración reabren, con motivo. Lo hace cumplir el servidor
// (closeSectionGradebook / reopenSectionGradebook).

export function SectionActaPage(): JSX.Element {
  const { t } = useTranslation('sis');
  const navigate = useNavigate();
  const { sectionId = '' } = useParams<{ sectionId: string }>();
  const { currentTenantId } = useTenantStore();

  const headerQ = useQuery({
    queryKey: ['section-acta-header', currentTenantId, sectionId],
    enabled: !!currentTenantId && !!sectionId,
    queryFn: async () => {
      const section = (
        await getDoc(doc(db, `tenants/${currentTenantId}/sections/${sectionId}`))
      ).data();
      if (!section) return null;
      return { termId: section['termId'] as string };
    },
  });
  const header = headerQ.data;

  return (
    // COMPACTA PARA UNA NOTEBOOK (1366×768, 1440×900): la tabla tiene que
    // empezar en el primer tercio de la pantalla. El título, el resultado y las
    // acciones van en UNA franja dentro del libro (`acta`); la explicación, tras
    // «¿Qué es el acta?».
    <Box sx={{ px: { xs: 2, sm: 3 }, py: { xs: 1.5, sm: 2 } }}>
      <Button
        size="small"
        startIcon={<ArrowBackRounded />}
        onClick={() => navigate(header?.termId ? `/sections/term/${header.termId}` : '/sections')}
        sx={{ mb: 1 }}
      >
        {t('acta.back')}
      </Button>
      {sectionId && <GradesPage embeddedSectionId={sectionId} acta />}
    </Box>
  );
}
